(() => {
  const validTypes = new Set(['all', 'restaurants', 'hotels', 'collaborations']);
  const validCountries = new Set(['all', 'nederland', 'belgie', 'duitsland']);

  const getType = (root) => {
    const currentHandle = root.dataset.currentPageHandle;
    const url = new URL(window.location.href);

    if (currentHandle === root.dataset.allPageHandle) {
      const opensOverview = url.hash === '#partner-overzicht' || url.searchParams.has('country');
      return opensOverview ? 'all' : '';
    }
    if (currentHandle === root.dataset.restaurantsPageHandle) return 'restaurants';
    if (currentHandle === root.dataset.hotelsPageHandle) return 'hotels';
    if (currentHandle === root.dataset.collaborationsPageHandle) return 'collaborations';

    // Backwards-compatible preview fallback. Generated storefront links use full page slugs.
    const value = url.searchParams.get('partner_type');
    return validTypes.has(value) ? value : '';
  };

  const getCountry = () => {
    const value = new URL(window.location.href).searchParams.get('country') || 'all';
    return validCountries.has(value) ? value : 'all';
  };

  const updateCountryUrl = (country) => {
    const url = new URL(window.location.href);

    if (country && country !== 'all') {
      url.searchParams.set('country', country);
    } else {
      url.searchParams.delete('country');
    }

    window.history.pushState({}, '', url);
  };

  const applyView = (root, shouldScroll = false) => {
    const type = getType(root);
    const choices = root.querySelector('[data-fpartners-choices]');
    const overview = root.querySelector('[data-fpartners-overview]');
    const empty = root.querySelector('[data-fpartners-empty]');
    const countrySelect = root.querySelector('[data-fpartners-country]');

    if (!choices || !overview) return;

    const showOverview = Boolean(type);
    choices.hidden = showOverview;
    overview.hidden = !showOverview;

    if (!showOverview) return;

    const cards = [...root.querySelectorAll('[data-partner-type]')];
    const country = getCountry();
    let visibleCount = 0;

    cards.forEach((card) => {
      const typeMatches = type === 'all' || card.dataset.partnerType === type;
      const countryMatches = country === 'all' || card.dataset.partnerCountry === country;
      const visible = typeMatches && countryMatches;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (countrySelect) countrySelect.value = country;

    if (empty) empty.hidden = visibleCount > 0;

    if (shouldScroll) {
      overview.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-fpartners-root]').forEach((root) => {
      if (root.dataset.fpartnersReady === 'true') return;
      root.dataset.fpartnersReady = 'true';

      root.addEventListener('change', (event) => {
        const countrySelect = event.target.closest('[data-fpartners-country]');
        if (!countrySelect) return;

        updateCountryUrl(countrySelect.value);
        applyView(root, false);
      });

      applyView(root, false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.addEventListener('popstate', () => {
    document.querySelectorAll('[data-fpartners-root]').forEach((root) => applyView(root, false));
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
